// Complementary Products - Add multiple items to cart
class ComplementaryProducts {
  constructor() {
    this.productForm = document.querySelector('product-form:not([data-sticky])');
    this.form = this.productForm?.querySelector('form');
    this.submitButton = this.form?.querySelector('button[type="submit"]');

    console.log('Constructor - productForm:', this.productForm);
    console.log('Constructor - form:', this.form);
    console.log('Constructor - submitButton:', this.submitButton);

    if (this.productForm && this.form && this.submitButton) {
      this.init();
    } else {
      console.warn('ComplementaryProducts: Missing required elements');
    }
  }

  init() {
    console.log('Init - Adding submit event listener');
    // Intercept form submission with capture phase
    this.form.addEventListener('submit', (e) => {
      console.log('Submit event captured!');
      const selectedComplementary = this.getSelectedComplementaryProducts();
      console.log('Selected complementary products:', selectedComplementary);

      if (selectedComplementary.length > 0) {
        console.log('Preventing default and adding to cart...');
        e.preventDefault();
        e.stopImmediatePropagation();
        this.addMultipleToCart(selectedComplementary);
      } else {
        console.log('No complementary products selected, letting form submit normally');
      }
      // If no complementary products selected, let form submit normally
    }, true); // Use capture phase
  }

  getSelectedComplementaryProducts() {
    const parent_container = document.querySelector(`.wim-product-blocks--buy-buttons[data-main-product-id="${this.productForm.parentElement.parentElement.getAttribute('data-main-product-id')}"]`);
    const products = parent_container ? parent_container.getAttribute('data-upsell-products').split(',').reduce((previous_item, current_item) => {
      if (current_item.trim() != '') {
        previous_item.push({
          id: current_item,
          quantity: 1
        });
      }
      return previous_item;
    }, []) : [];

    return products;
  }

  getMainProduct() {
    const formData = new FormData(this.form);
    return {
      id: formData.get('id'),
      quantity: parseInt(formData.get('quantity') || 1)
    };
  }

  async addMultipleToCart(complementaryProducts) {
    const mainProduct = this.getMainProduct();

    // Disable button and show loading state
    this.setLoadingState(true);

    // Prepare items array with main product and complementary products
    const items = [mainProduct, ...complementaryProducts];

    console.log('Adding to cart:', items); // Debug log

    try {
      const response = await fetch(window.Shopify?.routes?.root + 'cart/add.js' || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const data = await response.json();

      if (!response.ok) {
        console.error('Cart add error:', data);
        throw new Error(data.description || 'Failed to add to cart');
      }

      console.log('Cart add success:', data); // Debug log

      // Update cart count immediately
      await this.updateCartCount();

      // Trigger cart notification/drawer
      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification) {
        if (typeof cartNotification.setActiveElement === 'function') {
          cartNotification.setActiveElement(document.activeElement);
        }
        if (typeof cartNotification.open === 'function') {
          cartNotification.open();
        }
      }

      // Try to open cart drawer
      await this.openCartDrawer();

      document.querySelectorAll('.wim-product-card-upsell.active').forEach(card => {
        card.classList.remove('active');
      });
      document.querySelector(`.wim-product-blocks--buy-buttons[data-main-product-id="${this.productForm.parentElement.parentElement.getAttribute('data-main-product-id')}"]`).setAttribute('data-upsell-products', '');

    } catch (error) {
      console.error('Error adding products to cart:', error);
      this.showError(error.message || 'Error al agregar productos al carrito. Por favor, inténtalo de nuevo.');
    } finally {
      this.setLoadingState(false);
    }
  }

  showError(message) {
    alert(message);
  }

  setLoadingState(loading) {
    if (loading) {
      this.submitButton.disabled = true;
      this.submitButton.classList.add('loading');
    } else {
      this.submitButton.disabled = false;
      this.submitButton.classList.remove('loading');
    }
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      console.log('Cart count:', cart.item_count);

      // Update all cart count elements
      const cartCountElements = document.querySelectorAll('.cart-count-bubble span, [data-cart-count]');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;

        // Show bubble if there are items
        const bubble = element.closest('.cart-count-bubble');
        if (bubble) {
          if (cart.item_count > 0) {
            bubble.classList.remove('hidden');
          } else {
            bubble.classList.add('hidden');
          }
        }
      });

      return cart;
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  async openCartDrawer() {
    try {
      // Method 1: Try cart-notification element
      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification && typeof cartNotification.renderContents === 'function') {
        console.log('Opening cart-notification...');
        await cartNotification.renderContents();
        return;
      }

      // Method 2: Try cart-drawer element
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        console.log('Opening cart-drawer...');
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          cartDrawer.classList.add('active');
        }

        // Refresh cart drawer content
        const response = await fetch('/cart?section_id=cart-drawer');
        if (response.ok) {
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newContent = doc.querySelector('cart-drawer');

          if (newContent) {
            cartDrawer.innerHTML = newContent.innerHTML;
          }
        }
        return;
      }

      // Method 3: Click on cart icon
      console.log('Trying to click cart icon...');
      const cartIcon = document.querySelector('.header__icon--cart');
      if (cartIcon) {
        cartIcon.click();
      }
    } catch (error) {
      console.error('Error opening cart drawer:', error);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('Initializing ComplementaryProducts...');
    const comp = new ComplementaryProducts();
    console.log('ComplementaryProducts initialized:', comp);
  });
} else {
  console.log('Initializing ComplementaryProducts (immediate)...');
  const comp = new ComplementaryProducts();
  console.log('ComplementaryProducts initialized:', comp);
}

